import * as Yup from "yup";

export function initialValues(teacher) {
  return {
    avatar: teacher?.avatar || "",
    fileAvatar: null,
    firstname: teacher?.firstname || "",
    lastname: teacher?.lastname || "",
    email: teacher?.email || "",
    password: "",
    active: teacher?.active !== undefined ? teacher.active : true,
  };
}

export function validationSchema(teacher, t) {
  return Yup.object({
    firstname: Yup.string().required(t("teachers:validation.nameRequired")),
    lastname: Yup.string().required(t("teachers:validation.lastNameRequired")),
    email: Yup.string()
      .email(t("teachers:validation.emailInvalid"))
      .required(t("teachers:validation.emailRequired")),
    password: teacher
      ? Yup.string()
      : Yup.string().required(t("teachers:validation.passwordRequired")),
  });
}
